import React, { useState, useEffect } from "react";
import { Row, Col } from 'react-bootstrap';
import apiClient from "../../../api/apiClient";
import { GETROLEWISEREPORT, DOWNLOADUSERWISEREPORT, GETROLEWISEREPORTSUMMARY, GETCOURSEWISEREPORT,ALLCOURSERATINGSUMMERY } from '../../../utils/ApiEndPoint';
import { TotalCoursesIcon, CompleteIcon, InprocessCoursesIcon, PendingCoursesIcon } from '../../../utils/FontIcon';
import { getInitialName } from '../../../utils/utils';
import { Input } from "../../shared";

import {
    Chart as ChartJS,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
    ArcElement,
} from 'chart.js';
import { Bubble, Doughnut, Pie } from 'react-chartjs-2';

ChartJS.register(LinearScale, PointElement, Tooltip, Legend);
ChartJS.register(ArcElement, Tooltip, Legend);
const ROLE_BUBBLE_METRICS = [
    { 
        key: 'totalCourses', 
        label: 'Total', 
        x: 2,//Math.random(1, 10),// 
        y: 16,//Math.random(1,20),// 
        color: '#36a2eb' 
    },
    { 
        key: 'totalCompleted', 
        label: 'Completed', 
        x: 2,//Math.random(1, 10),// 
        y: 8,//Math.random(1,20),// 
        color: '#9BDFC4' 
    },
    { 
        key: 'totalInProgress', 
        label: 'In Progress', 
        x: 7,//Math.random(1, 10),// 
        y: 12,//Math.random(1,20),// 
        color: '#FFB44F' 
    },
    { 
        key: 'totalPending', 
        label: 'Pending', 
        x: 6,//Math.random(1, 10),//10 
        y: 4,//Math.random(1,20),//2 
         color: '#F99BAB' 
    }
];

const getBubbleRadius = (value) => {
    const numericValue = Number(value) || 0;
    if (numericValue <= 0) return 0;
    return Math.max(20, Math.min(45, Math.sqrt(numericValue) * 2));
};

const buildRoleBubbleChart = (item) => ({
    roleName: item?.roleName || '',
    datasets: ROLE_BUBBLE_METRICS.map((metric) => ({
        label: metric.label,
        data: [
            {
                label: metric.label,
                roleName: item?.roleName || '',
                rawValue: Number(item?.[metric.key]) || 0,
                x: metric.x,
                y: metric.y,
                r: getBubbleRadius(item?.[metric.key]),//getBubbleRadius(50000),//
            }
        ],
        backgroundColor: metric.color,
        borderColor: metric.color.replace('0.85', '1'),
        borderWidth: 1
    }))
});

const bubbleCenterLabelPlugin = {
    id: 'bubbleCenterLabelPlugin',
    afterDatasetsDraw: (chart) => {
        const { ctx } = chart;
        const datasets = chart.data?.datasets || [];
        if (!datasets.length) return;

        ctx.save();
        ctx.fillStyle = '#1f2d3d';
        ctx.font = '600 12px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        datasets.forEach((dataset, datasetIndex) => {
            const datasetMeta = chart.getDatasetMeta(datasetIndex);
            if (!datasetMeta) return;

            datasetMeta.data.forEach((point, index) => {
                const label = dataset.data?.[index]?.label || '';
                if (label) {
                    ctx.fillText(getInitialName(label), point.x, point.y);
                }
            });
        });

        ctx.restore();
    }
};
ChartJS.register(bubbleCenterLabelPlugin);

const pieLegendGapPlugin = {
    id: 'pieLegendGapPlugin',
    beforeInit: (chart) => {
        if (!['pie', 'doughnut', 'bubble'].includes(chart.config.type)) return;
        if (chart.options?.plugins?.legend?.position !== 'top') return;

        const originalFit = chart.legend?.fit;
        if (!originalFit) return;

        chart.legend.fit = function fit() {
            originalFit.bind(this)();
            this.height += 20;
        };
    }
};
ChartJS.register(pieLegendGapPlugin);

const legendLetterSpacingPlugin = {
    id: 'legendLetterSpacingPlugin',
    beforeInit: (chart) => {
        const originalDraw = chart.legend?.draw;
        if (!originalDraw) return;

        chart.legend.draw = function draw() {
            const spacing = chart.options?.plugins?.legend?.labels?.letterSpacing ?? 0;
            const { ctx } = chart;
            const previousLetterSpacing = ctx.letterSpacing;

            if (spacing > 0 && typeof previousLetterSpacing !== 'undefined') {
                ctx.letterSpacing = `${spacing}px`;
            }

            originalDraw.bind(this)();

            if (typeof previousLetterSpacing !== 'undefined') {
                ctx.letterSpacing = previousLetterSpacing;
            }
        };
    }
};
ChartJS.register(legendLetterSpacingPlugin);
export const bubbleOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            min: 0,
            max: 10,
            ticks: {
                // display: false,
                stepSize: 1,
                callback: (value) => {
                    if (value === 0) return '0';
                    return `${value}K`;
                }
            },
            grid: {
                color: '#d7dce2',
                drawBorder: true
            }
        },
        y: {
            min: 0,
            max: 20,
            ticks: {
                // display: false,
                stepSize: 1,
                callback: (value) => {
                    if (value === 0) return '0';
                    return `${value}K`;
                }
            },
            grid: {
                color: '#d7dce2',
                drawBorder: false
            }
        }
    },
    plugins: {
        legend: {
            display: true,
            position: 'top',
            margin:'200px',
            labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                boxWidth: 20,
                // padding: 20,
                letterSpacing: 0.2
            }
        },
        tooltip: {
            callbacks: {
                label: function (context) {
                    const role = context.raw?.roleName || '';
                    const metric = context.raw?.label || context.dataset?.label || '';
                    const value = context.raw?.rawValue ?? 0;
                    return [
                        `Role: ${role}`,
                        `${metric}: ${value}`
                    ];
                }
            }
        }
    },
};

export const pieOptions = {
    responsive: true,
    maintainAspectRatio: true,
    // cutout: '40%',
    radius: '100%',
    updateMode: "reset",
    plugins: {
        legend: {
            display: true,
            position: 'top',
            labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                boxWidth: 20,
                // padding: 10,
                letterSpacing: 0.2
            }
        },
        datalabels: {
            color: '#000',
        }
    }
};

export default function Rolewisetracking() {
    const [courseType, setCourseType] = useState(0);
    const [roleType, setRoleType] = useState(0);
    const [ratingType, setRatingType] = useState(0);
    const [rolewiseSummary, setRolewiseSummary] = useState({});
    const [roleWiseData, setRoleWiseData] = useState([]);
    const [courseWiseData, setCoureseWiseData] = useState([]);
    const [ratingData, setRatingData] = useState([]);
    const GetRollWiseReport = () => {
        apiClient.get(GETROLEWISEREPORT)
            .then((response) => {
                if (response.status === 200) {
                    const shortedonNameData = response.data.sort((a, b) => a.roleName.localeCompare(b.roleName));
                    const updatedRoleWiseData = (shortedonNameData || []).map(buildRoleBubbleChart);
                    setRoleWiseData(updatedRoleWiseData);
                }

            }).catch((error) => {

            }).finally(() => {

            });
    }
    const GetCourseWiseReport = () => {
        apiClient.get(GETCOURSEWISEREPORT)
            .then((response) => {
                if (response.status === 200) {
                    const shortedonNameData = response.data.sort((a, b) => a.courseName.localeCompare(b.courseName));
                    const updatedCourseWiseData = shortedonNameData.map(item => {
                        return (
                            {
                                totalEnrolled: item.totalUsers,
                                courseName: item.courseName,
                                labels: ['Completed', 'In progress', 'Pending'],
                                datasets: [
                                    {
                                        label: `${item.courseName}`,
                                        data: [item.totalCompleted, item.totalInProgress, item.totalPending],
                                        backgroundColor: [
                                            '#9BDFC4',
                                            '#FFB44F',
                                            '#F99BAB',
                                        ],
                                        borderColor: [
                                            '#9BDFC4',
                                            '#FFB44F',
                                            '#F99BAB',
                                        ],
                                        borderWidth: 1,
                                    },
                                ],
                            }
                        );
                    })
                    setCoureseWiseData(updatedCourseWiseData)
                }

            }).catch((error) => {

            }).finally(() => {

            });
    }
    const getRollWiseSummary = () => {
        apiClient.get(GETROLEWISEREPORTSUMMARY)
            .then((response) => {
                if (response.status === 200) {
                    setRolewiseSummary(response.data)
                }
            }).catch((error) => {

            }).finally(() => {

            });
    }
    const getAllCourseRatingSummery = () => {
        apiClient.get(ALLCOURSERATINGSUMMERY)
            .then((response) => {
                if (response.status === 200) {
                    const ratingSummary = response.data || {};
                    const totalRatedCourses = ratingSummary.totalRatedCourses || 0;
                    const ratingDistribution = {
                        0: totalRatedCourses,
                        1: ratingSummary.rated1Courses || 0,
                        2: ratingSummary.rated2Courses || 0,
                        3: ratingSummary.rated3Courses || 0,
                        4: ratingSummary.rated4Courses || 0,
                        5: ratingSummary.rated5Courses || 0,
                    };
                    setRatingData([
                        {
                            name: 'All Ratings',
                            labels: [
                                'Rating 5',
                                'Rating 4',
                                'Rating 3',
                                'Rating 2',
                                'Rating 1'
                            ],
                            datasets: [{
                                data: [ratingDistribution[5], ratingDistribution[4], ratingDistribution[3], ratingDistribution[2], ratingDistribution[1]],
                                backgroundColor: [
                                    '#E6B94D',
                                    '#FFCD56',
                                    '#FFD778',
                                    '#FFE6AB',
                                    '#FFF0CC',


                                ],
                                hoverOffset: 4
                            }]
                        },
                        {
                            name: 'Rating 1',
                            labels: [
                                'Rating 1',
                            ],
                            datasets: [{
                                data: [ratingDistribution[1]],
                                backgroundColor: [
                                    '#FFF0CC',,
                                ],
                                hoverOffset: 4
                            }]
                        },
                        {
                            name: 'Rating 2',
                            labels: [
                                'Rating 2',
                            ],
                            datasets: [{
                                data: [ratingDistribution[2]],
                                backgroundColor: [
                                    '#FFE6AB',,
                                ],
                                hoverOffset: 4
                            }]
                        },
                        {
                            name: 'Rating 3',
                            labels: [
                                'Rating 3',
                            ],
                            datasets: [{
                                data: [ratingDistribution[3]],
                                backgroundColor: [
                                    '#FFD778',,
                                ],
                                hoverOffset: 4
                            }]
                        },
                        {
                            name: 'Rating 4',
                            labels: [
                                'Rating 4',
                            ],
                            datasets: [{
                                data: [ratingDistribution[4]],
                                backgroundColor: [
                                   '#FFCD56',
                                ],
                                hoverOffset: 4
                            }]
                        },
                        {
                            name: 'Rating 5',
                            labels: [
                                'Rating 5'
                            ],
                            datasets: [{
                                data: [ratingDistribution[5]],
                                backgroundColor: [
                                    '#E6B94D',
                                ],
                                hoverOffset: 4
                            }]
                        }
                    ]);
                }
            }).catch((error) => {

            }).finally(() => {

            });
    }
    useEffect(() => {
        getRollWiseSummary();
        GetRollWiseReport();
        GetCourseWiseReport();
        getAllCourseRatingSummery();
    }, []);
    const handleChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case 'courseType':
                setCourseType(value);
                break;
            case 'roleType':
                setRoleType(value);
                break;
            case 'ratingType':
                setRatingType(value);
                break;
            default:
                break;
        }
    };
    return (
        <>
            <Row className='justify-content-center align-items-center'>
                <Col sm={12} className="count-card-bg">
                    <Row>
                        <Col lg={3} className="summary-container">
                            <span style={{ fontWeight: '600', fontSize: '1.35rem' }}>Overall</span>
                            <span className="summary-txt">Summary</span>
                        </Col>
                        <Col lg={9}>
                            <Row>
                                <Col lg={3} md={6}>
                                    <div className="count-card-container total">
                                        <span className="count-card-icon total-icon" aria-label="Total Enrolled Icon"><TotalCoursesIcon /></span>
                                        <span className="count-no" aria-label="Total Enrolled Count">{rolewiseSummary?.totalCourses || 0}</span>
                                        <span className="fs-small12">Total Enrolled</span>
                                    </div></Col>
                                <Col lg={3} md={6}>
                                    <div className="count-card-container complete">
                                        <span className="count-card-icon complete-icon" aria-label="Completed Course Icon"><CompleteIcon /></span>
                                        <span className="count-no" aria-label="Completed Course Count">{rolewiseSummary?.totalCompleted || 0}</span>
                                        <span className="fs-small12">Completed</span>
                                    </div>
                                </Col>
                                <Col lg={3} md={6}>
                                    <div className="count-card-container inprocess">
                                        <span className="count-card-icon inprocess-icon" aria-label="Inprocess Course Icon"><InprocessCoursesIcon /></span>
                                        <span className="count-no" aria-label="Inprocess Course Count">{rolewiseSummary?.totalInProgress || 0}</span>
                                        <span className="fs-small12">In-Progress</span>
                                    </div>
                                </Col>
                                <Col lg={3} md={6}>
                                    <div className="count-card-container pending">
                                        <span className="count-card-icon pending-icon" aria-label="Pending Course Icon"><PendingCoursesIcon /></span>
                                        <span className="count-no" aria-label="Pending Course Count">{rolewiseSummary?.totalPending || 0}</span>
                                        <span className="fs-small12">Pending</span>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row className='justify-content-center align-items-center'>
                <Col lg={4} md={12} sm={12}>
                    <div className="report-card-container border rounded-3 mb-3">
                        <div className="d-block p-3 pb-0 border-bottom border-1">
                            <h5 className="mb-4">Role Wise Report</h5>
                            <Input
                                label="Select Role"
                                isMandetory={false}
                                name="roleType"
                                type="select"
                                value={roleType}
                                onChange={handleChange}
                                multiple={false}
                                options={roleWiseData.map((item, index) => ({ label: item.roleName, value: index }))}
                            />
                        </div>
                        <div className='report-graph-container'>
                            {roleWiseData?.[Number(roleType)]?.datasets?.length > 0 ? (
                                <Bubble
                                    options={bubbleOptions}
                                    data={roleWiseData[roleType]}
                                />
                            ) : (
                                <div className="d-flex justify-content-center align-items-center">
                                    <span className="fs-6">No data available</span>
                                </div>
                            )}
                        </div>
                    </div>
                </Col>
                <Col lg={4} md={12} sm={12}>
                    <div className="report-card-container border rounded-3 mb-3">
                        <div className="d-block p-3 pb-0 border-bottom border-1">
                            <h5 className="mb-4">Course Wise Report</h5>
                            <Input
                                label="Select Course"
                                isMandetory={false}
                                name="courseType"
                                type="select"
                                value={courseType}
                                onChange={handleChange}
                                multiple={false}
                                options={courseWiseData.map((item, index) => ({ label: item.courseName, value: index }))}
                            />
                        </div>
                        <div className='report-graph-container'>
                            {courseWiseData?.[Number(courseType)]?.totalEnrolled ? (<Doughnut
                                options={{
                                    ...pieOptions,
                                    cutout: '40%',
                                }}
                                data={courseWiseData[Number(courseType)]}
                            />) :
                                <div className="d-flex justify-content-center align-items-center">
                                    <span className="fs-6">No data available</span>
                                </div>
                            }

                        </div>
                    </div>
                </Col>
                <Col lg={4} md={12} sm={12}>
                    <div className="report-card-container border rounded-3 mb-3">
                        <div className="d-block p-3 pb-0 border-bottom border-1">
                            <h5 className="mb-4">Rating Wise Report</h5>
                            <Input
                                label="Select Rating"
                                isMandetory={false}
                                name="ratingType"
                                type="select"
                                value={ratingType}
                                onChange={handleChange}
                                multiple={false}
                                options={[
                                    { label: 'All Ratings', value: 0 },
                                    { label: 'Rating 1', value: 1 },
                                    { label: 'Rating 2', value: 2 },
                                    { label: 'Rating 3', value: 3 },
                                    { label: 'Rating 4', value: 4 },
                                    { label: 'Rating 5', value: 5 },
                                ]}
                            />
                        </div>
                        <div className='report-graph-container'>
                            {ratingData?.[Number(ratingType)]? (
                                <Pie
                                    options={pieOptions}
                                    data={ratingData[ratingType]}
                                />
                            ) : (
                                <div className="d-flex justify-content-center align-items-center">
                                    <span className="fs-6">No data available</span>
                                </div>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
}
